<template>
  <div>
    <div class="breadcrumb-div" @mouseenter="toggleRegions(true)" @mouseleave="toggleRegions(false)">
      <span class="breadcrumb-link" ref="region-link" @click="toggleRegions(true)" >{{ regionName }}</span>
      <transition name="slide-fade">
        <div v-if="regionsPopupVisible" class="inner-content">
          <div class="inner-breadcrumb-content z-depth-3">
            <table class="breadcrumb-table striped highlight">
              <thead>
                <th>
                  <span>{{ $t('views.breadcrumb.region') }}</span>
                  <span class="right" @click="toggleRegions(false)"><i class="material-icons clickable">cancel</i></span>
                </th>
              </thead>
              <tbody>
                <tr v-for="(item, index) in regions" :key="index">
                  <td @click="selectRegion(item)"><span :class="{'clickable': item.Departments != null && item.Departments.length > 0, 'greyedout': item.Departments == null || item.Departments.length < 1}">{{ item.Name }}</span></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </transition>
    </div>
    <!-- breadcrumb part child objects -->
    <div v-if="selectedRegionId || railObject != null" class="breadcrumb-div breadcrumb-link">&nbsp;/&nbsp;</div>
    <div v-if="selectedRegionId || railObject != null" class="breadcrumb-div" @mouseenter="toggleDepartments(true)" @mouseleave="toggleDepartments(false)">
      <span class="breadcrumb-link" ref="dept-link" @click="toggleDepartments(true)">{{ departmentName }}</span>
      <transition name="slide-fade">
        <div v-if="departmentsPopupVisible" class="dialog no-padding inner-content">
          <div class="inner-breadcrumb-content z-depth-3">
            <table class="breadcrumb-table striped highlight">
              <thead>
                <th>
                  <span>{{ $t('views.breadcrumb.department') }}</span>
                  <span class="right" @click="toggleDepartments(false)"><i class="material-icons clickable">cancel</i></span>
                </th>
              </thead>
              <tbody>
                <tr v-for="(item, index) in departments" :key="index">
                  <td @click="selectDepartment(item)"><span class="clickable" v-bind:class="{ 'alarm': item.monitorStatusId===3, 'warning': item.monitorStatusId===2, 'clickable': item.Complexes != null && item.Complexes.length > 0, 'greyedout': item.Complexes == null || item.Complexes.length < 1}">{{ item.Name }}</span></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </transition>
    </div>
    <div v-if="selectedDepartmentId || railObject != null" class="breadcrumb-div breadcrumb-link">&nbsp;/&nbsp;</div>
    <div v-if="selectedDepartmentId || railObject != null" class="breadcrumb-div" @mouseenter="toggleComplexes(true)" @mouseleave="toggleComplexes(false)">
      <span class="breadcrumb-link" @click="toggleComplexes(true)">{{ complexName }}</span>
      <transition name="slide-fade">
        <div v-if="complexesPopupVisible" class="dialog no-padding inner-content">
          <div class="inner-breadcrumb-content z-depth-3">
            <table class="breadcrumb-table striped highlight">
              <thead>
                <th>
                  <span>{{ $t('views.breadcrumb.complex') }}</span>
                  <span class="right" @click="toggleComplexes(false)"><i class="material-icons clickable">cancel</i></span>
                </th>
              </thead>
              <tbody>
                <tr v-for="(item, index) in complexSorted(complexes)" :key="index">
                  <td @click="selectComplex(item)"><span :class="{'clickable': numberOfRailObjects(item.ComplexId) > 0, 'greyedout': numberOfRailObjects(item.ComplexId) < 1}">{{ item.Name }}</span></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </transition>
    </div>
    <div v-if="selectedComplexId || railObject != null" class="breadcrumb-div breadcrumb-link">&nbsp;/&nbsp;</div>
    <div v-if="selectedComplexId || railObject != null" class="breadcrumb-div" @mouseenter="toggleRailObjects(true)" @mouseleave="toggleRailObjects(false)">
      <span class="breadcrumb-link-main" @click="toggleRailObjects(true);selectParentRailObject(railObject)">{{ railObjectName }}</span>
      <transition name="slide-fade">
        <div v-if="railobjectsPopupVisible" class="dialog no-padding inner-content">
          <div class="inner-breadcrumb-content z-depth-3">
            <table class="breadcrumb-table striped highlight">
              <thead>
                <th>
                  <span>{{ $t('views.breadcrumb.railobject') }}</span>
                  <span class="right" @click="toggleRailObjects(false)"><i class="material-icons clickable">cancel</i></span>
                </th>
              </thead>
              <tbody>
                <tr v-for="(item, index) in railObjectSorted(railObjects)" :key="index">
                  <td @click="selectRailObject(item)"><span class="clickable">{{ item.Name }}</span></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </transition>
    </div>
    <div class="breadcrumb-div breadcrumb-link">&nbsp;/&nbsp;</div>
  </div>
</template>
<script>
import UtilitiesService from '@/services/UtilitiesService'
import RailObjectService from '@/services/RailObjectService'
import Router from '../router/index'
import DepartmentService from '../services/DepartmentService'
import RegionService from '../services/RegionService'
import ComplexService from '../services/ComplexService'
import lodashfilter from '../../node_modules/lodash/filter'
import dropdown from '../../node_modules/vue-my-dropdown'
import _ from 'lodash'

export default {
  name: 'railObjectBreadCrumb',
  props: {
    railObjectId: [Number, null]
  },
  data () {
    return {
      railObject: null,
      selectedRegionId: null,
      selectedDepartmentId: null,
      selectedComplexId: null,
      selectedRailObjectId: null,
      position: ['left', 'center', 'left', 'top'],
      animation: 'ani-slide-y',
      regionsPopupVisible: false,
      departmentsPopupVisible: false,
      complexesPopupVisible: false,
      railobjectsPopupVisible: false,
      hoverTimer: null,
      hoverTime: 300
    }
  },
  components: {
    dropdown
  },
  watch: {
    railObjectId: function (val) {
      if (val) {
        this.railObject = RailObjectService.getRailObjectByRailObjectId(val)
        if (this.railObject) {
          this.selectedRailObjectId = this.railObject.RailObjectId
          this.selectedComplexId = this.railObject.ComplexId
          this.selectedDepartmentId = this.railObject.DepartmentId
          this.selectedRegionId = this.railObject.RegionId
        }
      }
    }
  },
  computed: {
    regionName: function () {
      if (this.selectedRegionId) {
        var region = RegionService.getRegionByRegionId(this.selectedRegionId)
        return region.Name
      } else {
        return this.$t('views.breadcrumb.select')
      }
    },
    departmentName: function () {
      if (this.selectedDepartmentId) {
        var dept = DepartmentService.getDepartmentByDepartmentId(this.selectedDepartmentId)
        return dept.Name
      } else {
        return this.$t('views.breadcrumb.select')
      }
    },
    complexName: function () {
      if (this.selectedComplexId) {
        var complex = ComplexService.getComplexByComplexId(this.selectedComplexId)
        return complex.Name
      } else {
        return this.$t('views.breadcrumb.select')
      }
    },
    railObjectName: function () {
      if (this.railObject) {
        return this.railObject.Name
      } else {
        return this.$t('views.breadcrumb.select')
      }
    },
    regions: function () {
      let regions = RegionService.getRegions()
      return _.orderBy(regions, ['Name'], ['asc'])
    },
    departments: function () {
      let departments = []
      if (this.selectedRegionId) {
        departments = DepartmentService.getDepartmentsByRegionId(this.selectedRegionId)
      } else {
        departments = DepartmentService.getDepartments()
      }
      return _.orderBy(departments, ['Name'], ['asc'])
    },
    complexes: function () {
      if (this.selectedDepartmentId) {
        let complexes = ComplexService.getComplexesByDepartmentId(this.selectedDepartmentId)
        return _.orderBy(complexes, ['Name'], ['asc'])
      } else {
        return []
      }
    },
    railObjects: function () {
      if (this.selectedComplexId) {
        var lst = RailObjectService.getRailObjectsByComplexId(this.selectedComplexId)
        var filteredList1 = lodashfilter(lst, {PossObjectGroupId: 1})
        var filteredList2 = lodashfilter(lst, {PossObjectGroupId: 4})
        var filteredList3 = lodashfilter(lst, {PossObjectGroupId: 3})
        var filteredList = filteredList1.concat(filteredList3, filteredList2)
        return _.orderBy(filteredList, ['Name'], ['asc'])
      } else {
        return []
      }
    }
  },
  methods: {
    complexSorted: function (complexes) {
      return UtilitiesService.complexSorted(complexes)
    },
    railObjectSorted: function (complexRailObjects) {
      return UtilitiesService.railObjectsSorted(complexRailObjects)
    },
    numberOfRailObjects (complexId) {
      var lst = RailObjectService.getRailObjectsByComplexId(complexId)
      var filteredList1 = lodashfilter(lst, {PossObjectGroupId: 1})
      var filteredList2 = lodashfilter(lst, {PossObjectGroupId: 4})
      var filteredList3 = lodashfilter(lst, {PossObjectGroupId: 3})
      var filteredList = filteredList1.concat(filteredList3, filteredList2)
      return filteredList.length
    },
    selectRegion (item) {
      if (item.Departments == null || item.Departments.length < 1) {
        return
      }
      this.selectedRegionId = item.RegionId
      this.selectedDepartmentId = null
      this.selectedComplexId = null
      this.selectedRailObjectId = null
      this.railObject = null
      this.$emit('update:railObjectId', null)
      this.regionsPopupVisible = false
      this.departmentsPopupVisible = true
    },
    selectDepartment (item) {
      if (item.Complexes == null || item.Complexes.length < 1) {
        return
      }
      this.selectedDepartmentId = item.DepartmentId
      this.selectedComplexId = null
      this.selectedRailObjectId = null
      this.railObject = null
      this.$emit('update:railObjectId', null)
      this.departmentsPopupVisible = false
      this.complexesPopupVisible = true
    },
    selectComplex (item) {
      if (this.numberOfRailObjects(item.ComplexId) < 1) {
        return
      }
      this.selectedComplexId = item.ComplexId
      this.selectedRailObjectId = null
      this.railObject = null
      this.$emit('update:railObjectId', null)
      this.complexesPopupVisible = false
      this.railobjectsPopupVisible = true
    },
    selectRailObject (item) {
      // console.log(item)
      if (item) {
        this.selectedRailObjectId = item.RailObjectId
        this.railObject = RailObjectService.getRailObjectByRailObjectId(item.RailObjectId)
        if (item.PossObjectGroupId === 1 || item.PossObjectGroupId === 4) {
          Router.push({
            name: 'Switch',
            params: {
              id: this.railObject.RailObjectId
            },
            props: true
          })
          localStorage.setItem('lastRoute', '/switch/' + this.railObject.RailObjectId)
          // this.$emit('update:railObjectId', item.RailObjectId)
          this.$emit('set-parent', item.RailObjectId)
          this.railobjectsPopupVisible = false
        }
        if (item.PossObjectGroupId === 3 && item.PossObjectCodeId === 5) {
          Router.push({
            name: 'AxleShunt',
            params: {
              id: this.railObject.RailObjectId
            },
            props: true
          })
          localStorage.setItem('lastRoute', '/axleshunt/' + this.railObject.RailObjectId)
          // this.$emit('update:railObjectId', item.RailObjectId)
          this.$emit('set-parent', item.RailObjectId)
          this.railobjectsPopupVisible = false
        }

        if (item.PossObjectGroupId === 3 && item.PossObjectCodeId === 11) {
          Router.push({
            name: 'AxleCounter',
            params: {
              railobjectid: this.railObject.RailObjectId
            },
            props: true
          })
          localStorage.setItem('lastRoute', '/axlecounter/' + this.railObject.RailObjectId)
          // this.$emit('update:railObjectId', item.RailObjectId)
          this.$emit('set-parent', item.RailObjectId)
          this.railobjectsPopupVisible = false
        }

        // Mixed signals
        if (item.PossObjectGroupId === 4 && item.PossObjectCodeId === 12) {
          Router.push({
            name: 'MixedSignals',
            params: {
              railobjectid: this.railObject.RailObjectId,
              railObject: this.railObject
            },
            props: true
          })
          localStorage.setItem('lastRoute', '/mixedsignals/' + this.railObject.RailObjectId)
          // this.$emit('update:railObjectId', item.RailObjectId)
          this.$emit('set-parent', item.RailObjectId)
          this.railobjectsPopupVisible = false
        }
      }
    },
    selectParentRailObject (item) {
      this.$emit('set-parent', item.RailObjectId)
      // this.$parent.$emit('set-parent', item)
    },
    toggleRegions (state) {
      clearTimeout(this.hoverTimer)
      if (state) {
        this.hoverTimer = setTimeout(() => {
          this.railobjectsPopupVisible = false
          this.complexesPopupVisible = false
          this.departmentsPopupVisible = false
          this.regionsPopupVisible = state
        }, this.hoverTime)
      } else {
        this.regionsPopupVisible = state
      }
    },
    toggleDepartments (state) {
      clearTimeout(this.hoverTimer)
      if (state) {
        this.hoverTimer = setTimeout(() => {
          this.regionsPopupVisible = false
          this.railobjectsPopupVisible = false
          this.complexesPopupVisible = false
          this.departmentsPopupVisible = state
        }, this.hoverTime)
      } else {
        this.departmentsPopupVisible = state
      }
    },
    toggleComplexes (state) {
      clearTimeout(this.hoverTimer)
      if (state) {
        this.hoverTimer = setTimeout(() => {
          this.regionsPopupVisible = false
          this.railobjectsPopupVisible = false
          this.departmentsPopupVisible = false
          this.complexesPopupVisible = state
        }, this.hoverTime)
      } else {
        this.complexesPopupVisible = state
      }
    },
    toggleRailObjects (state) {
      clearTimeout(this.hoverTimer)
      if (state) {
        this.hoverTimer = setTimeout(() => {
          this.regionsPopupVisible = false
          this.complexesPopupVisible = false
          this.departmentsPopupVisible = false
          this.railobjectsPopupVisible = state
        }, this.hoverTime)
      } else {
        this.railobjectsPopupVisible = state
      }
    },
    toggleAll (state) {
      this.regionsPopupVisible = state
      this.departmentsPopupVisible = state
      this.complexesPopupVisible = state
      this.railobjectsPopupVisible = state
    }
  }
}
</script>

<style scoped>
  .breadcrumb-div {
    display: inline-block;
  }
   .breadcrumb-link {
    font-family: Roboto;
    font-size: 24px;
    font-weight: normal;
    font-style: normal;
    line-height: 32px;
    color: rgba(0,0,0, .56);
    /* cursor: pointer; */
  }
  .breadcrumb-div:not(.breadcrumb-link) {
    cursor: pointer;
  }
  .breadcrumb-link-main {
    font-family: Roboto;
    font-size: 24px;
    font-weight: normal;
    font-style: normal;
    line-height: 32px;
    color: rgba(0, 0, 0, 0.87);
    /* cursor: pointer; */
  }
  .inner-breadcrumb-content {
    max-height: 300px;
    width: 345px;
    overflow-y: auto;
    background-color: white;
    /* border: 1px solid  rgba(0, 0, 0, 0.56); */
    font-family: Roboto;
  }
  .breadcrumb-table {
    position: relative;
  }
  .breadcrumb-table thead tr {
    border-top: 1px solid rgba(0, 0, 0, 0.4);
    border-bottom: 1px solid rgba(0, 0, 0, 0.4);
  }
  .breadcrumb-table th, .breadcrumb-table td {
    padding: 5px 5px;
  }
  .inner-content {
    position: fixed;
    z-index: 4;
  }
  .slide-fade-enter-active {
    transition: all .4s ease;
  }
  .slide-fade-leave-active {
    transition: all .2s ease;
  }
  .slide-fade-enter {
    transform: translateY(-50px);
    opacity: 0;
  }
  .slide-fade-leave-to {
    transform: translateY(-50px);
    opacity: 0;
  }
  table.highlight tbody tr:hover {
    background-color: #eee !important;
 }
 .alarm {
  color: red
}

.warning {
  color: orange
}

.greyedout {
  opacity: 0.5;
}
</style>



// WEBPACK FOOTER //
// src/components/RailObjectBreadCrumb.vue